import React, { createContext, useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

interface OneClickLoginCodeContextType {
  oneClickLoginCode: string | null;
  clearOneClickLoginCode: () => void;
}

const OneClickLoginCodeContext = createContext<OneClickLoginCodeContextType>({
  oneClickLoginCode: null,
  clearOneClickLoginCode: () => {},
});

/**
 * Provider component that extracts the login code from URL
 * and makes it available throughout the app
 */
export function OneClickLoginCodeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [searchParams] = useSearchParams();
  const [oneClickLoginCode, setOneClickLoginCode] = useState<string | null>(
    null,
  );

  useEffect(() => {
    const codeFromUrl = searchParams.get("code");

    // Only set the code if it's not empty or whitespace
    if (codeFromUrl && codeFromUrl.trim() !== "") {
      setOneClickLoginCode(codeFromUrl);
    }
  }, [searchParams]);

  const clearOneClickLoginCode = () => {
    setOneClickLoginCode(null);
  };

  return (
    <OneClickLoginCodeContext.Provider
      value={{
        oneClickLoginCode,
        clearOneClickLoginCode,
      }}
    >
      {children}
    </OneClickLoginCodeContext.Provider>
  );
}

/**
 * Hook to access the login code from the context
 */
export function useOneClickLoginCode() {
  return useContext(OneClickLoginCodeContext);
}
